class MECEvents {
  constructor() {
    this.container = document.querySelector('.js-events-calendar');
    this.wrap = this.container.querySelector('.mec-full-calendar-wrap');

    this.locationsJSON = document.querySelector('.locations__json');
    this.locationsObj = JSON.parse(this.locationsJSON.innerHTML);

    this.descriptionsJSON = document.querySelector('.descriptions__json');
    this.descriptionsObj = JSON.parse(this.descriptionsJSON.innerHTML);

    this.formatsJSON = document.querySelector('.formats__json');
    this.formatsObj = JSON.parse(this.formatsJSON.innerHTML);

    this.subjectsJSON = document.querySelector('.subjects__json');
    this.subjectsObj = JSON.parse(this.subjectsJSON.innerHTML);

    this.altLocationsJSON = document.querySelector('.alt_locations__json');
    this.altLocationsObj = JSON.parse(this.altLocationsJSON.innerHTML);

    this.locationSelect;
    this.categorySelect;
    this.labelSelect;

    this.listViewListener = false;
    this.mutationsListener = false;
    this.elementPosition = 0;
    this.articlesList = [];
    this.init();
  }

  init() {
    // Get shortcode for events
    this.eventShortcodeID = this.container.querySelector('.mec-wrap').id.substring(9);
    const eventsListContainer = this.wrap.querySelector('.mec-skin-list-events-container');

    // Switch labels and categories to format and subject matter respectively
    const dropdowns = document.querySelectorAll('.mec-dropdown-search');
    dropdowns.forEach(dropdown => {
      const select = dropdown.querySelector('select');

      switch (select.id) {
        case `mec_sf_location_${this.eventShortcodeID}`:
          this.locationSelect = select;

          dropdown.parentElement.appendChild(dropdown);
          break;

        case `mec_sf_category_${this.eventShortcodeID}`:
          this.categorySelect = select;

          dropdown.parentElement.prepend(dropdown);
          select.innerHTML = '<option value="" selected="selected">Subject Matter</option>';

          /* eslint-disable */
          for (const [key, value] of Object.entries(this.subjectsObj)) {
            const option = document.createElement('option');
            option.value = value;
            option.classList.add('level-0');
            option.innerHTML = key;
            option.dataset.type = key.toLowerCase();
            select.appendChild(option);
          }
          /* eslint-enable */

          break;

        case `mec_sf_label_${this.eventShortcodeID}`:
          this.labelSelect = select;

          dropdown.parentElement.prepend(dropdown);
          select.innerHTML = '<option value="" selected="selected">Format</option>';

          /* eslint-disable */
          for (const [key, value] of Object.entries(this.formatsObj)) {
            if (key !== 'Cancelled' && key !== 'Rescheduled') {
              const option = document.createElement('option');
              option.value = value;
              option.classList.add('level-0');
              option.innerHTML = key;
              option.dataset.type = key.toLowerCase();
              select.appendChild(option);
            }
          }
          /* eslint-enable */
          break;
      }

      dropdown.classList.add('hidden');
    });

    // Add IDs to articles and store their descriptions
    const articles = eventsListContainer.querySelectorAll('.mec-event-article');
    articles.forEach(article => {
      const share = article.querySelector('.mec-event-sharing-wrap');
      if (share) {
        share.remove();
      }
    });

    // Jump to anchor IDs if in the URL
    const url = window.location.href;
    const hashPos = url.indexOf('#');

    if (hashPos > -1) {
      const id = url.substring(hashPos + 1);
      const el =  document.getElementById(id);

      if (el) {
        const bounding = el.getBoundingClientRect();
        setTimeout(() => {
          window.scroll({ top: bounding.top });
        }, 500);
      }
    }

    // Add accessibility to the view nav
    const items = document.querySelectorAll('.mec-totalcal-view span');

    items.forEach(item => {
      item.setAttribute('tabindex', '0');

      // Add keyboard click functionality
      item.addEventListener('keypress', event => {

        // event.keyCode or event.which  property will have the code of the pressed key
        const keyCode = event.keyCode ? event.keyCode : event.which;

        // 13 points the enter key
        if (keyCode === 13) {
          // call click function of the button
          item.click();
        }
      });
    });

    // Create modal result so I can just attach the mutation observer immediately
    this.modalResult = document.createElement('div');
    this.modalResult.classList.add('mec-modal-result');

    this.wrap.appendChild(this.modalResult);

    // Add the class mutation listener for the list view
    // this.addMutationListener();
    this.setupDirectionsAndLocations();
    this.useQueryValues();
  }

  useQueryValues() {
    // Get query parameters and set the dropdowns
    const queryParams = document.querySelector('.query_params');
    this.subject = queryParams.dataset.subject;
    this.format = queryParams.dataset.format;
    let selection;
    const event = new Event('change');

    if (this.subject) {
      const subjectDD = document.querySelector(`#mec_sf_category_${this.eventShortcodeID}`);
      selection = subjectDD.querySelector(`[data-type='${this.subject}']`);

      if (selection) {
        subjectDD.value = selection.value;

        setTimeout(() => {
          subjectDD.dispatchEvent(event);
        }, 500);
      }
    }
    if (this.format) {
      const formatDD = document.querySelector(`#mec_sf_label_${this.eventShortcodeID}`);
      selection = formatDD.querySelector(`[data-type='${this.format}']`);

      if (selection) {
        formatDD.value = selection.value;

        setTimeout(() => {
          formatDD.dispatchEvent(event);
        }, 500);
      }
    }

    const locationDD = document.querySelector(`#mec_sf_location_${this.eventShortcodeID}`);
    locationDD.value = '';

    setTimeout(() => {
      locationDD.dispatchEvent(event);
    }, 500);
  }

  addMutationListener() {
    this.onClassChange(this.modalResult, node => {
      if (!node.classList.contains('mec-month-navigator-loading')) {
        if (!this.mutationsListener) {
          this.mutationsListener = true;

          // set view to monthly
          this.listViewListener = false;
          const listButton = document.querySelector('.mec-totalcal-listview');
          listButton.click();
        } else {
          this.setupDirectionsAndLocations();
        }
      }
    });
  }

  setupDirectionsAndLocations() {
    const eventsListContainer = document.querySelector('.mec-skin-list-events-container');
    let articles;
    let ribbonContainer;

    if (eventsListContainer) { // List View
      const mecWrap = eventsListContainer.querySelector('.mec-wrap');
      if (mecWrap) {
        mecWrap.classList.remove('mec-wrap');
        mecWrap.classList.add('mec-wrap-updated');
      }

      articles = document.querySelectorAll('.mec-event-article, .mec-month-divider');

      articles.forEach(article => {
        if (article.tagName.toLowerCase() === 'article') {
          if (!this.listViewListener) {
            this.onElementAddedToListView();
          }

          // Hide other tours
          const subjectMatters = article.querySelectorAll('.mec-categories-wrapper .mec-category a');
          subjectMatters.forEach(subjectMatter => {
            if (subjectMatter.innerHTML.indexOf('Other Tours') > -1) {
              subjectMatter.parentElement.remove();
            }
          });

          const anchor = article.querySelector('a.mec-color-hover');
          const instance = this.articlesList.find(({ val }) => val === anchor.href);

          if (!instance) {
            this.articlesList.push({ val: anchor.href, pos: this.elementPosition, element: article });
            this.elementPosition ++;

            const venue = article.querySelector('.mec-venue-details span');
            if (venue) {
              const newVenue = this.locationsObj[venue.innerHTML] !== false ? this.locationsObj[venue.innerHTML] : venue.innerHTML !== 'undefined' ? venue.innerHTML : '';
              venue.innerHTML = newVenue;

              const eventId = article.querySelector('[data-event-id]') ? article.querySelector('[data-event-id]').dataset.eventId : null;
              if (eventId && this.altLocationsObj[eventId]) {
                this.altLocationsObj[eventId].forEach(altLocation => {
                  venue.innerHTML += `<br>${altLocation}`;
                });
              }
            }

            ribbonContainer = article.querySelector('.mec-event-meta');
            this.fixRibbons(article, ribbonContainer);
          }
        }
      });

      if (
        this.locationSelect.value !== '' ||
        this.categorySelect.value !== '' ||
        this.labelSelect.value !== ''
      ) {
        this.listViewListener = false;
        return;
      }

      const sortedElements = this.articlesList.sort((a, b) => a.pos - b.pos);

      const listStandard = document.createElement('div');
      listStandard.classList.add('mec-event-list-standard');
      sortedElements.forEach(element => {
        listStandard.appendChild(element.element);
      });

      const wrap = document.createElement('div');
      wrap.classList.add('mec-wrap-updated');
      wrap.appendChild(listStandard);

      eventsListContainer.replaceChildren();
      eventsListContainer.appendChild(wrap);
    } else { // Any non-list view
      articles = document.querySelectorAll('.mec-event-article');

      // reset Articles List
      this.articlesList = [];
      this.elementPosition = 0;
      this.listViewListener = false;

      const weeklyEvents = document.querySelector('.mec-weekly-view-dates-events');
      const dailyEvents = document.querySelector('.mec-daily-view-dates-events');

      articles.forEach(article => {
        const loc = article.querySelector('.mec-event-detail .mec-event-loc-place');
        if (loc) {
          const newLoc = (this.locationsObj[loc.innerHTML] !== false && this.locationsObj[loc.innerHTML] !== undefined) ? this.locationsObj[loc.innerHTML] : loc.innerHTML !== 'undefined' ? loc.innerHTML : '';
          loc.innerHTML = newLoc;

          const eventId = article.querySelector('[data-event-id]') ? article.querySelector('[data-event-id]').dataset.eventId : null;
          if (eventId && this.altLocationsObj[eventId]) {
            this.altLocationsObj[eventId].forEach(altLocation => {
              loc.innerHTML += `<br>${altLocation}`;
            });
          }
        }

        const title = article.querySelector('.mec-color-hover');
        if (title) {
          const descriptionText = this.descriptionsObj[title.dataset.eventId] !== false ? this.descriptionsObj[title.dataset.eventId] : '';
          const descContainer = document.createElement('div');
          descContainer.classList.add('mec-event-description');
          descContainer.innerHTML = descriptionText;

          const monthlyContents = article.querySelector('.mec-monthly-contents');
          if (monthlyContents) {
            ribbonContainer = article.querySelector('.mec-monthly-contents');
            article.classList.add('mec-label-custom');

            monthlyContents.appendChild(descContainer);
          } else {
            ribbonContainer = article;

            const contents = document.createElement('div');
            contents.classList.add('mec-monthly-contents');
            article.appendChild(contents);
            contents.appendChild(article.querySelector('.mec-event-time'));
            contents.appendChild(article.querySelector('.mec-event-title'));
            contents.appendChild(article.querySelector('.mec-event-detail'));

            const format = article.querySelector('.mec-categories-wrapper');

            if (format) {
              contents.appendChild(format);
            }

            if (weeklyEvents) {
              contents.style.width = 'calc(100% - 160px)';
            } else if (dailyEvents) {
              contents.style.width = 'calc(100% - 85px)';
            }
            contents.appendChild(descContainer);
          }
          this.fixRibbons(article, ribbonContainer);
        }
      });
    }
    if (!this.mutationsListener) {
      this.addMutationListener();
    }
  }

  fixRibbons(article, ribbonContainer) {
    // add sold out and sale ended ribbons
    let placement = 0;
    const middleBanner = article.querySelector('.mec-event-label-captions');

    // Check for "Members" category and add a ribbon
    const categories = article.querySelectorAll('.mec-categories-wrapper .mec-category a');
    categories.forEach(category => {
      if (category.innerHTML.indexOf('Members') > -1) {
        const membersRibbon = document.createElement('span');
        membersRibbon.classList.add('mec-event-label-captions', 'mec-event-label-captions-one', 'members-ribbon');
        // membersRibbon.dataset.placement = ++placement;
        membersRibbon.innerHTML = 'Members Only';

        ribbonContainer.appendChild(membersRibbon);

        category.remove();
      }
    });

    // Existing code for other ribbons (Waitlist, etc.)
    const virtual = article.querySelector('.mec-shortcode-virtual-badge');
    if (virtual) {
      const vRibbon = document.createElement('span');
      vRibbon.classList.add('mec-event-label-captions', 'mec-event-label-captions-one');
      vRibbon.dataset.placement = ++placement;
      vRibbon.innerHTML = 'Hybrid';

      ribbonContainer.appendChild(vRibbon);
      virtual.remove();
      if (middleBanner) {
        middleBanner.dataset.placement = ++placement;
      }
    } else if (middleBanner) {
      middleBanner.dataset.placement = ++placement;
    }

    const banner = article.querySelector('.mec-event-title-soldout .soldout');
    let ribbonText;
    let ribbonClass;

    if (banner) {
      if (banner.innerHTML.toLowerCase() === 'sold out') {
        ribbonClass = 'waitlist';
        ribbonText = 'Waitlist';
      } else if (banner.innerHTML.toLowerCase() === 'sale has ended') {
        ribbonClass = 'closed';
        ribbonText = 'Registration Closed';
      } else if (banner.innerHTML.toLowerCase() === 'last few tickets') {
        ribbonClass = 'few';
        ribbonText = 'Last Few Tickets';
      }

      const ribbon = document.createElement('span');
      ribbon.classList.add('mec-event-label-captions', 'mec-event-label-captions-two', ribbonClass);
      ribbon.dataset.placement = ++placement;
      ribbon.innerHTML = ribbonText;

      ribbonContainer.appendChild(ribbon);
      banner.parentElement.remove();
    }

    if (placement > 0) {
      if (document.querySelector('.mec-calendar-topsec')) {
        article.classList.add('extra-values');
        article.classList.add('mec-label-custom');
        article.dataset.placements = placement;
      } else {
        ribbonContainer.classList.add('extra-values');
        ribbonContainer.classList.add('mec-label-custom');
        ribbonContainer.dataset.placements = placement;
      }
    }
  }

  // Helper function to tell if an element is added to the list view
  onElementAddedToListView() {
    this.listViewListener = true;

    const eventsListContainer = document.querySelector('.mec-skin-list-events-container');

    const observer = new MutationObserver(() => {
      const mecWrap = eventsListContainer.querySelector('.mec-wrap');
      if (!mecWrap) {
        this.addListener = true;
      } else {
        this.setupDirectionsAndLocations();
      }
    });

    observer.observe(eventsListContainer, { childList: true, attributes: true });
    return observer.disconnect;
  }

  // A class to update when an elements classes change
  onClassChange(element, callback) {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          callback(mutation.target);
        }
      });
    });

    observer.observe(element, { attributes: true });
    return observer.disconnect;
  }
}

export default MECEvents;
